import { t } from "@lingui/core/macro";
import { LocationType } from "../api/locationApi.ts";
import RadioGroup, { IconRadioOption } from "./RadioGroup.tsx";

interface IconRadioGroupProps {
  selectedValue: LocationType;
  onChange: (value: LocationType) => void;
  label?: string;
}

function LocationRadioGroup(props: IconRadioGroupProps) {
  const selectableOptions: IconRadioOption[] = [
    { label: t`In Person`, value: "IN_PERSON", icon: "House" },
    { label: t`Remote & In Person`, value: "BOTH", icon: "HousePlus" },
    { label: t`Remote`, value: "REMOTE", icon: "MonitorPlay" },
  ];
  return (
    <RadioGroup
      name={"locations"}
      options={selectableOptions}
      selectedValue={props.selectedValue}
      onChange={(value) => props.onChange(value as LocationType)}
      label={props.label}
    ></RadioGroup>
  );
}

export default LocationRadioGroup;
